import PrimaryDefaultButton from '@/components/buttons/primary/DefaultButton';
import styled from 'styled-components';


const PrimaryOuterGlowButton = styled(PrimaryDefaultButton)`

`;

export default PrimaryOuterGlowButton;
